import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity Organisation
 */
@Entity()
export class Organisation extends Partner {
  static override _class = 'Organisation';

  override get type() {
    return KooperationsPartner.ORGANISATION;
  }
}
